import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type CityStoreCity
 */
const initialState = {
  cityList: { loading: false, data: null, error: null }
};

export const CitySlice = createSlice({
  name: 'city',
  initialState,
  reducers: {
    fetchCityListRequest: (state, action) => {
      state.cityList.loading = true;
      state.cityList.error = null;
    },
    fetchCityListSuccess: (state, action) => {
      state.cityList.data = action.payload;
      state.cityList.loading = false;
      state.cityList.error = null;
    },
    fetchCityListFailure: (state, action) => {
      state.cityList.data = null;
      state.cityList.loading = false;
      state.cityList.error = action.payload;
    }
  }
});

export const {
  fetchCityListRequest,
  fetchCityListSuccess,
  fetchCityListFailure
} = CitySlice.actions;
/**
 *
 * @param {*} store
 * @returns {CityStoreCity['cityList']}
 */
export const getCityListState = (store) => store.city?.cityList;

export default CitySlice.reducer;
